import React from 'react';

export function PublicCompetitionCombinedEvents({ competitionName }) {
    return (
        <div>
            <h3>Mehrkämpfe für {competitionName}</h3>
            <p>Hier werden die Mehrkämpfe angezeigt.</p>
            {/* TODO: Mehrkämpfe-Logik implementieren */}
        </div>
    );
}
